import CajaMensualForm from './CajaMensualForm'
export {CajaMensualForm}
export default CajaMensualForm
